export default "__VITE_ASSET__DtUuBeVv__"